module.exports = __webpack_public_path__ + "img/selected7-min.ff6b9f45.png";